module.exports = __webpack_public_path__ + "img/repair.6fadb12c.svg";